import Admin from "./Admin";
import Broker from "./Broker";
import Guest from "./Guest";

const screens = ({ user }) =>
  user
    ? [...Broker(user?.permissions), ...Admin(user?.permissions), ...Guest]
    : Guest;

export default screens;
